import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

interface LoginApiResponse {
  success: boolean;
  data?: {
    token: string;
    admin: Record<string, unknown>;
  };
}

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  private readonly LOGIN_URL = `${environment.apiUrl}/auth/login`;

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap((event) => {
        if (event instanceof HttpResponse && request.url === this.LOGIN_URL) {
          const body = event.body as LoginApiResponse;
          if (body?.success && body?.data?.token) {
            localStorage.setItem(
              'currentUser',
              JSON.stringify({ token: body.data.token, admin: body.data.admin ?? {} })
            );
          }
        }
      })
    );
  }
}
